export default "__VITE_PUBLIC_ASSET__aa39c301__"